import { useEffect, useRef } from "react";

/**
 * Ensures the provided function runs only once after the component mounts.
 * Stable under React Strict Mode double-invocation in development.
 */
export const useRunOnceAfterMount = (func: () => void): void => {
  const hasRunRef = useRef(false);
  useEffect(() => {
    if (!hasRunRef.current) {
      func();
    }
    hasRunRef.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
